import { useEffect, useRef } from "react";

// Remembers the window scroll position per key (in sessionStorage) and restores
// it once `ready` becomes true — so returning to a list lands where you left off.
export function useScrollRestore(key, ready) {
  const storeKey = `scroll:${key}`;
  const restored = useRef(false);

  useEffect(() => {
    const onScroll = () => sessionStorage.setItem(storeKey, String(window.scrollY));
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [storeKey]);

  useEffect(() => {
    if (!ready || restored.current) return;
    restored.current = true;
    const y = Number(sessionStorage.getItem(storeKey) || 0);
    if (y <= 0) return;
    // Retry over ~1s so late-loading content (that grows page height) still lands right.
    let n = 10;
    const attempt = () => {
      window.scrollTo(0, y);
      n -= 1;
      if (n > 0 && Math.abs(window.scrollY - y) > 4) setTimeout(attempt, 100);
    };
    requestAnimationFrame(attempt);
  }, [ready, storeKey]);
}
